/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormGroup, ValidationErrors} from '@angular/forms';
import {ENTER} from '@angular/cdk/keycodes';
import {ID} from '../../../_enums/constants';
import {isControlInvalid, isControlValid, TOUCHED_OR_SUBMITTED} from '../../../_enums/form-validation';

@Component({
  selector: 'app-input-address',
  templateUrl: './input-address.component.html',
  styleUrls: ['./input-address.component.scss']
})
export class InputAddressComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                             BASE COMPONENT INPUTS                                                                                  ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() controlName?: string;
  @Input() disableEnterKeyPress?: boolean;
  @Input() formGroup?: FormGroup;
  @Input() index?: number;
  @Input() label?: string;
  @Input() readonly ?: boolean;
  @Input() showLabel?: boolean;
  @Input() showRequired?: boolean;
  @Input() showValidation?: string;
  @Input() submitted?: boolean;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                             COMPONENT OUTPUTS                                                                                      ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Output() updated = new EventEmitter<string>();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    this.controlName = 'address';
    this.disableEnterKeyPress = false;
    this.formGroup = null;
    this.index = 0;
    this.label = null;
    this.readonly = false;
    this.showLabel = true;
    this.showRequired = true;
    this.showValidation = TOUCHED_OR_SUBMITTED;
    this.submitted = false;
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORM CONTROLS GETTERS                                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get control(): AbstractControl | null {
    return this.formGroup ? this.formGroup.get(this.controlName) : null;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get controlId(): string {
    return `${this.controlName}_${this.index}_${ID}`;
  }

  get required(): boolean {
    return this.validators && this.validators.hasOwnProperty('required');
  }

  get showInvalid(): boolean {
    return isControlInvalid(this.control, this.showValidation, this.submitted);
  }

  get showValid(): boolean {
    return isControlValid(this.control, this.showValidation);
  }

  get validators(): ValidationErrors | null {
    return this.control && this.control.validator && this.control.validator(this.control);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              CHANGE LISTENERS                                                                                      ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public onChange(e): void {
    if (e && e.target) {
      this.updated.emit(e.target.value);
    }
  }

  public keypress(e): void {
    if (e.keyCode === ENTER && this.disableEnterKeyPress) {
      e.preventDefault();
    }
  }
}
